import React from 'react';

function ConversionProgress({ currentFile, totalFiles }) {
  return (
    <div className="text-center mt-4">
      <div className="flex flex-col items-center">
        <div className="w-full max-w-xs bg-gray-200 rounded-full h-2.5 mb-4">
          <div 
            className="bg-blue-600 h-2.5 rounded-full transition-all duration-500"
            style={{ width: `${(currentFile / totalFiles) * 100}%` }}
          ></div>
        </div>
        <p className="text-sm text-gray-600">
          Converting file {currentFile} of {totalFiles}
        </p>
      </div>
    </div>
  );
}

export default ConversionProgress;
